'use client';

import styles from './SuspenseLoader.module.css';

export const SuspenseLoader = () => {
  return (
    <div className={styles.container}>
      <div className={styles.spinner} />
    </div>
  );
};
